
<div (click)="navigateToAddInventory()">
  <i class="fa fa-eye" aria-hidden="true"  style="margin-left: 30px;"></i>
</div>